import React, { ReactElement } from 'react';
import './footer.scss';
import cn from 'classnames';
import FooterTemplate from './FooterTemplate';
import TermsAndConditionsLink from "./TermsAndConditionsLink";
import PrivacyPolicy from "./PrivacyPolicy";

export interface FooterProps {
    className?: string;
}

const LoggedOutFooter: React.FunctionComponent<FooterProps> = ({ className }: FooterProps): ReactElement => {
    return (
        <FooterTemplate
            className={cn('footer', className)}
            footerLinks={ 
                <ul>
                    <li>
                        <TermsAndConditionsLink>Website Terms and Conditions</TermsAndConditionsLink>
                    </li>
                    <li>
                        <PrivacyPolicy>Privacy Policy</PrivacyPolicy>
                    </li>
                </ul>
            }
        />
    );
};

export default LoggedOutFooter;
